import React, { useState } from 'react';
import { Card, Button, Accordion, Row, Col, Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
const AariDetail = () => {
    const navigate = useNavigate(); 

    const handleScrollToContact = () => {
        // Navigate to contact page and append hash for scrolling to form
        navigate('/aari-form');
    };



    return (
        <>
            <div className="bg-dark text-white">
      {/* Hero Section */}
      <Container className="py-5">
        <Row className="align-items-center">
          <Col sm={12} md={12} lg={6}>
            <h1 className="fw-bold">Embroidery and Aari Work Course</h1>
            <p className="mt-3">
            Embroidery and Aari Course introduces students to the timeless art of needlework and thread decoration. From basic stitches to intricate designs, this course is ideal for beginners and aspiring professionals who want to master hand embroidery.
            </p>
            <div className="d-flex gap-3 mt-4">
              <span className="badge bg-secondary p-2"><i class="fa-solid fa-clock-rotate-left" style={{color: "#ffffff"}}></i> 6 Month Course</span>
              <span className="badge bg-secondary p-2"><i class="fa-regular fa-hourglass-half" style={{color: "#ffffff"}}></i> 1 Hour Session</span>
              <span className="badge bg-secondary p-2"><i class="fa-solid fa-book-open" style={{color: "#ffffff"}}></i> 50+ Lessons</span>
            </div>
            <Button variant="primary" className="mt-4 p-3 px-5" onClick={handleScrollToContact}>
              Apply Now
            </Button>
          </Col>
         
        </Row>
      </Container>

      {/* Course Details Section */}
      <Container fluid className="bg-light text-dark py-5">
        <Row>
          <Col sm={12} md={12} lg={2} className="ps-5">
            <ul className="list-unstyled">
              <li className="fw-bold">Course Overview</li>
              <li>What you'll learn</li>
              <li>Syllabus</li>
              <li>Course Instructor</li>
              <li>Projects</li>
              <li>Student Review</li>
            </ul>
          </Col>
          <Col sm={12} md={12} lg={10} className="px-5">
            <h2 className="fw-bold">Embroidery and Aari Work Course</h2>
            <hr />
            <p>
            Learn intricate hand embroidery and Aari techniques, including chain, satin, and tambour stitches. Master fabric handling, design motifs, and embellishments like beads and sequins for professional, decorative garment finishes.
            </p>
            <h3 className="fw-bold">Foundational Skills</h3>
            <hr />
            <p> Learn Aari and hand embroidery, including stitches, motifs, and embellishments, creating beautifully finished garments with professional decorative designs. </p>

            <div className="py-5">
      {/* What You'll Learn Section */}
      <h2 className="fw-bold">What you'll learn</h2>
      <hr />
      <Row className="gy-4">
        <Col sm={12} md={12} lg={3}>
          <h4 style={{color:'#e69d00'}} className="fw-bold">01</h4>
          <h5 className="fw-bold">Basic Embroidery Stitches</h5>
          <p>Learn hand stitches, satin, chain, and backstitch for fabric decoration..</p>
        </Col>
        <Col sm={12} md={12} lg={3}>
          <h4 className="fw-bold" style={{color:'#e69d00'}}>02</h4>
          <h5 className="fw-bold">Aari Techniques</h5>
          <p>Master the use of Aari hooks, tambour work, and creating motifs.</p>
        </Col>
        <Col sm={12} md={12} lg={3}>
          <h4 className="fw-bold" style={{color:'#e69d00'}}>03</h4>
          <h5 className="fw-bold">Fabric & Material Knowledge</h5>
          <p>Identify suitable fabrics like cotton, silk, and georgette, and select threads, beads, and sequins.</p>
        </Col>
        <Col sm={12} md={12} lg={3}>
          <h4 className="fw-bold" style={{color:'#e69d00'}}>04</h4>
          <h5 className="fw-bold">Design & Finishing Skills</h5>
          <p> Practice adding embellishments, sequins, beads, and appliqué for professional results..</p>
        </Col>
      </Row>

      {/* Syllabus Section */}
      <h2 className="fw-bold mt-5">Syllabus</h2>
      <hr />
      <Row className="gy-4">
        <Col sm={12} md={12} lg={6}>
          <h4 className=""><span style={{color:'#e69d00'}}>01</span> Basic Stitches</h4>
         
          <ul className="section-title">
            <li>Chain</li>
            <li>Satin</li>
            <li>Backstitch</li>
          </ul>
        </Col>
        <Col sm={12} md={12} lg={6}>
          <h4 className=""><span style={{color:'#e69d00'}}>02</span> Aari Techniques</h4>
          <h5 className="fw-bold"></h5>
          <ul className="section-title">
            <li>Hook</li>
            <li>Tambour</li>
            <li>Motif</li>

          </ul>
        </Col>
        <Col sm={12} md={12} lg={6}>
          <h4 className=""><span style={{color:'#e69d00'}}>03</span>  Fabric & Materials</h4>
          <h5 className="fw-bold"></h5>
          <ul className="section-title">
            <li>Cotton</li>
            <li>Georgette</li>
            <li>Silk</li>
          </ul>
        </Col>
        <Col sm={12} md={12} lg={6}>
          <h4 className=""><span style={{color:'#e69d00'}}>04</span> Design & Finishing</h4>
          <h5 className="fw-bold"></h5>
          <ul className="section-title">
            <li>Sequins</li>
            <li>Beads</li>
            <li>Appliqué</li>
          </ul>
        </Col>
      </Row>
    </div>
          </Col>
        </Row>
        
      </Container>
      
      
    </div>

    
        </>
    );
};

export default AariDetail;